import React from 'react';
import PropTypes from 'prop-types';
import { IoMdTime } from 'react-icons/io';
import { FaCarSide, FaFlagCheckered } from 'react-icons/fa';

import { secondsToHHMMSS } from '../../../utils/time';
import {
  PULSE_THRESHOLD_SECONDS,
  STATE_COUNTDOWN,
  STATE_LAUNCHED,
  STATE_UPCOMING,
} from '../../../utils/launchWindows';
import {
  Container,
  Content,
  CountdownValue,
  DesktopText,
  IconWrapper,
  Message,
  MobileText,
} from './styles';

const LaunchWindowsBanner = ({ state, referenceLabel, remainingSeconds }) => {
  if (state === STATE_LAUNCHED) {
    return (
      <Container state={STATE_LAUNCHED} data-gtm-banner="subidas-lotes" data-state="lancamento">
        <Content key={STATE_LAUNCHED}>
          <Message emphasis>
            <DesktopText style={{ color: '#BCF738', marginRight: '4px' }}>
              Carros lançados agora!
            </DesktopText>
            <DesktopText>Foi dada a largada de novas disputas</DesktopText>
            <MobileText>Foi dada a largada de novas disputas</MobileText>
          </Message>
          <IconWrapper>
            <FaFlagCheckered color="#fff" size={24} aria-hidden />
          </IconWrapper>
        </Content>
      </Container>
    );
  }

  if (state === STATE_COUNTDOWN) {
    const pulsing = remainingSeconds <= PULSE_THRESHOLD_SECONDS;

    return (
      <Container state={STATE_COUNTDOWN} data-gtm-banner="subidas-lotes" data-state="contagem">
        <Content key={STATE_COUNTDOWN}>
          <Message>
            <DesktopText>Novos carros chegando em</DesktopText>
            <MobileText>Novos carros chegando em</MobileText>

            <CountdownValue
              key={remainingSeconds}
              pulsing={pulsing}
              id="banner-subidas-countdown"
              style={{ color: '#BCF738' }}
            >
              <IconWrapper>
                <IoMdTime color="#BCF738" size={24} aria-hidden />
              </IconWrapper>
              {secondsToHHMMSS(remainingSeconds)}
            </CountdownValue>
          </Message>
        </Content>
      </Container>
    );
  }

  // STATE_UPCOMING (padrão)
  return (
    <Container state={STATE_UPCOMING} data-gtm-banner="subidas-lotes" data-state="proxima-janela">
      <Content key={STATE_UPCOMING}>
        <IconWrapper>
          <IoMdTime color="#fff" size={24} aria-hidden />
        </IconWrapper>
        <Message>
          <DesktopText>Prepare-se para as novas oportunidades! Novos veículos às </DesktopText>
          <DesktopText style={{ color: '#8DFFFA', marginLeft: '4px' }}>
            {referenceLabel}
          </DesktopText>
          <MobileText>Novos veículos disponíveis às </MobileText>
          <MobileText style={{ color: '#8DFFFA', marginLeft: '4px' }}>{referenceLabel}</MobileText>
        </Message>
      </Content>
    </Container>
  );
};

LaunchWindowsBanner.propTypes = {
  state: PropTypes.oneOf([STATE_UPCOMING, STATE_COUNTDOWN, STATE_LAUNCHED]).isRequired,
  referenceLabel: PropTypes.string,
  remainingSeconds: PropTypes.number,
};

LaunchWindowsBanner.defaultProps = {
  referenceLabel: '',
  remainingSeconds: 0,
};

export default LaunchWindowsBanner;
